import { render, staticRenderFns } from "./TemplateDetailsModal.vue?vue&type=template&id=c7c4ce02&scoped=true&"
import script from "./TemplateDetailsModal.vue?vue&type=script&lang=js&"
export * from "./TemplateDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetailsModal.vue?vue&type=style&index=0&id=c7c4ce02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c4ce02",
  null
  
)

export default component.exports